@if (column().key === 'status') {
    @if (lastDeposit()?.status === Deposit.StatusEnum.IMPORTING && managementDataService.canManageDeposit()) {
        @if (managementDataService.abortingDepositIds().has(lastDeposit()!.id)) {
            <fa-icon
                class="text-error fa-spin"
                size="lg"
                [icon]="['fad', 'spinner-third']"
                [matTooltip]="'depositImportAbortInProgress' | transloco" />
        } @else {
            <button
                class="custom-button abort-import-button"
                type="button"
                [attr.aria-label]="'stopImport' | transloco"
                [matTooltip]="'stopImport' | transloco"
                (click)="abortImport($event)">
                <fa-icon
                    class="text-custom-blue fa-spin"
                    size="lg"
                    [icon]="['fad', 'spinner-third']" />
            </button>
        }
    } @else {
        <app-deposit-status
            [deposit]="lastDeposit()"
            [hasStandard]="!!depositFolder().standard" />
    }
} @else if (column().key === 'createdAt') {
    {{ depositFolder().createdAt ? (depositFolder().createdAt | date: translateService.localDate()) : '-' }}
} @else if (column().key === 'tags') {
    <div
        class="flex flex-row m-auto justify-center"
        [matTooltip]="'noPermissionToAddDeposit' | transloco"
        [matTooltipDisabled]="managementDataService.canManageDeposit()">
        <button
            class="custom-button add-patch"
            [class.extended-add-patch]="managementDataService.expandedElementId() === depositFolder().id"
            [disabled]="!managementDataService.canManageDeposit()"
            (click)="openAddDepositModal(depositFolder())">
            <fa-icon
                class="add-patch-icon"
                [icon]="['fas', 'plus']" />
        </button>
    </div>
} @else if (column().key === 'deleteData') {
    <div
        class="flex flex-row m-auto justify-center"
        matTooltipClass="whitespace-pre-line"
        matTooltipPosition="before"
        [matTooltip]="depositFolder().deleteData?.disabledMessage?.join('\n') ?? ('notPossibleDelete' | transloco)"
        [matTooltipDisabled]="depositFolder().deleteData?.isActive">
        <button
            class="custom-button delete"
            [class.extended-delete]="managementDataService.expandedElementId() === depositFolder().id"
            [disabled]="!depositFolder().deleteData?.isActive"
            (click)="openDeleteData(depositFolder())">
            <fa-icon
                class="delete-icon"
                [icon]="['fas', 'trash']" />
        </button>
    </div>
} @else if (column().key === 'updateData') {
    <div
        class="flex flex-row m-auto justify-center"
        [matTooltip]="'noPermissionToManageDeposit' | transloco"
        [matTooltipDisabled]="managementDataService.canManageDeposit()">
        <button
            class="custom-button add-patch"
            [class.extended-add-patch]="managementDataService.expandedElementId() === depositFolder().id"
            [disabled]="!managementDataService.canManageDeposit()"
            (click)="openUpdateData(depositFolder())">
            <fa-icon
                class="add-patch-icon"
                [icon]="['fas', 'pen']" />
        </button>
    </div>
} @else {
    {{ depositFolder()[column().key] }}
}
